import {Component, OnInit, ViewChild, ElementRef, OnDestroy, HostListener} from '@angular/core';
import { Subscription } from 'rxjs';
import { LiveChatService } from '../../services/live-chat.service';
import {MessagingService} from '../../services/messaging.service';
import {OfficeCommunicationMessageGroupModel} from '../../models/communication/office-communication-message-group.model';
import {OfficeCommunicationChatMessageModel} from '../../models/communication/office-communication-chat-message.model';
import {SignalrService} from '../../services/socket/signalr.service';
import {SocketConnectedUserModel} from '../../services/socket/models/socket-connected-user.model';
import {Globals} from '../../globals';
import {LocalStorageService} from '../../services/local-storage.service';
import {TdoUserConfigurationModel} from '../../models/configuration/user/tdo-user-configuration.model';
import {TdoChatDataModel} from './models/tdo-chat-data.model';
import {ChatReceiverTypeEnum} from '../../models/enum/chat-receiver-type.enum';
import {TdoChatConversationDataModel} from './models/tdo-chat-conversation-data.model';
import {ChatService} from '../../services/messaging/chat.service';
import {UserService} from '../../services/user.service';
import {SocketMessageModel} from '../../services/socket/models/socket-message.model';
import {NotificationStatusEnum} from '../../models/enum/notification/notification-status.enum';


@Component({
  selector: 'app-office-communication',
  templateUrl: './office-communication.component.html',
  styleUrls: ['./office-communication.component.scss']
})
export class OfficeCommunicationComponent implements OnInit, OnDestroy {
  @ViewChild('messageContainer') private messageContainer: ElementRef;

  messageGroups: OfficeCommunicationMessageGroupModel[] = [];
  selectedGroupIndex: number = -1;
  selectedGroup: OfficeCommunicationMessageGroupModel;
  inputMessage: string = '';
  userId: string = '1';

  scrollTimeout: any;
  chatServiceSubscription: Subscription;

  selectedConversation: TdoChatConversationDataModel;
  conversations: TdoChatConversationDataModel[];

  private isInitialized: boolean;
  private _selectedOnlineUser: SocketConnectedUserModel;

  @HostListener('document:click', ['$event'])
  checkIfClickOutside(event) {
    const tar = event.target;
    if (!this.el.nativeElement.contains(event.target) && this.isInitialized) {
      this.messagingService.sendComponentMessage('Toggle-Live-Chat-Display', {display: false});
    }
  }

  constructor(
    private el: ElementRef,
    private liveChatService: LiveChatService,
    private messagingService: MessagingService,
    public signalrService: SignalrService,
    private chatService: ChatService,
    private globals: Globals,
    private localStorageService: LocalStorageService,
    private userService: UserService
  ) {
    // this.userId = this.liveChatService.getCurrentUserId();
  }

  ngOnInit() {
    setTimeout(() => {
      this.isInitialized = true;
    }, 0.1);
    /*this.chatServiceSubscription = this.liveChatService.getMessageGroupsEvent.subscribe(messageGroups => {
      this.messageGroups = messageGroups;
      if (this.messageGroups && this.messageGroups.length > 0) {
        this.selectedGroup = this.messageGroups[0];
      }

      if (this.selectedGroupIndex === -1 && this.messageGroups.length) {
        this.selectedGroupIndex = 0;
      }

      this.changeSelectedGroup(this.selectedGroupIndex);
      this.scrollAfterGroupSelect();
    });*/

    if (this.signalrService.connectionExists) {
      this.signalrService.userConnected.subscribe((users) => {
        // this.connectedUsers = users;
      });

      this.signalrService.userDisconnected.subscribe((usersAfterDisconnect) => {

      });

      this.signalrService.messageUser.subscribe((res) => {
        switch (res.messageType) {
          case SocketMessageModel.TYPE_UPDATE_CHAT:
            this.chatService.getConversations(this.localStorageService.currentUserData.authdata.userid).subscribe((conversations) => {
              this.conversations = conversations;
              this.selectedConversation = this.conversations.find(p => p.ConversationID === this.selectedConversation.ConversationID);
              this.setMessagesAsSeen();
              this.scrollToBottom();
            });
            break;
        }
      });

      this.chatService.getConversations(this.localStorageService.currentUserData.authdata.userid).subscribe((conversations) => {
        this.conversations = conversations;
        const lastConversationId = localStorage.getItem('lastConversationId');
        if (lastConversationId) {
          this.selectedConversation = this.conversations.find(p => p.ConversationID === lastConversationId);
          this.setMessagesAsSeen();
        }

        if (this.signalrService.connectedUsers && this.signalrService.connectedUsers.length > 0) {
          let model = this.signalrService.connectedUsers.find(p => p.UserID === this.selectedConversation.UserID);
          if (model.UserID === this.localStorageService.currentUserData.authdata.userid) {
            model = this.signalrService.connectedUsers.find(p => p.UserID === this.selectedConversation.ReceiverID);
          }

          this.selectedOnlineUser = model as SocketConnectedUserModel;
        } else {
          this.signalrService.userConnected.subscribe((users) => {
            let model = this.signalrService.connectedUsers.find(p => p.UserID === this.selectedConversation.UserID);
            if (model.UserID === this.localStorageService.currentUserData.authdata.userid) {
              model = this.signalrService.connectedUsers.find(p => p.UserID === this.selectedConversation.ReceiverID);
            }
            this.selectedOnlineUser = model as SocketConnectedUserModel;
          });
        }

        this.scrollToBottom();
      });
    }
  }

  setMessagesAsSeen() {
    if (this.selectedConversation && this.selectedConversation.dataTDOChats) {
      const messagesToUpdate = this.selectedConversation.dataTDOChats.filter(p => p.ReceiverID === this.localStorageService.currentUserData.authdata.userid && p.enumNotificationStatusID === NotificationStatusEnum.NEW);
      const messageIdsToUpdate = messagesToUpdate.map(p => p.ChatID);
      if (messageIdsToUpdate.length > 0) {
        this.chatService.updateChatMessageStatus(messageIdsToUpdate, NotificationStatusEnum.READ).subscribe(() => {
          this.chatService.getNumUnreadMessages(this.localStorageService.currentUserData.authdata.userid).subscribe((num) => {
          });
        });
      }
    }
  }

  ngOnDestroy() {

  }

  isSelfUser(userId: string) {
    return userId === this.localStorageService.currentUserData.authdata.userid;
  }

  isConversationSelected(convo: TdoUserConfigurationModel) {
    if (!this._selectedOnlineUser) {
      return null;
    }
    return convo.UserID === this._selectedOnlineUser.UserID;
  }

  scrollAfterGroupSelect() {
    setTimeout(_ => {
      this.scrollToBottom();
    }, 1000);
  }

  getUnreadCountForGroup(group: OfficeCommunicationMessageGroupModel) {
    return group.messages.filter(msg => !msg.isRead).length;
  }

  onSendPressed() {
    if (this.inputMessage.trim() === '') {
      return false;
    }
    const message = new TdoChatDataModel();
    message.ConversationID = this.selectedConversation.ConversationID;
    message.SenderUserID = this.signalrService.connectedUser.UserID;
    message.ReceiverID = this._selectedOnlineUser.UserID;
    message.Message = this.inputMessage;
    message.enumChatReceverTypeID = ChatReceiverTypeEnum.User;
    this.chatService.saveChatMessage(message).subscribe((res) => {
      this.inputMessage = '';
      this.selectedConversation.dataTDOChats.push(res);
      this.scrollToBottom();
    });
  }

  onGroupClick(group: OfficeCommunicationMessageGroupModel) {
    this.selectedGroup = group;
  }

  onConversationClick(convo: TdoUserConfigurationModel) {
    this.selectedOnlineUser = convo as SocketConnectedUserModel;
    this.scrollToBottom();
  }

  getTime(timeString) {
    const date = new Date(timeString);
    return date.toLocaleString();
  }

  scrollToBottom(): void {
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = false;
    }

    try {
      this.scrollTimeout = setTimeout(_ => {
        this.messageContainer.nativeElement.scrollTop = this.messageContainer.nativeElement.scrollHeight;
      }, 1200);
    } catch (err) {
      console.log('error');
      this.scrollTimeout = setTimeout(_ => {
        this.scrollToBottom();
      }, 200);
    }
  }

  get selectedOnlineUser() {
    return this._selectedOnlineUser;
  }

  set selectedOnlineUser(user: SocketConnectedUserModel) {
    this._selectedOnlineUser = user;
    if (this.conversations) {
      this.selectedConversation = this.conversations.find(p => p.UserID === user.UserID || p.ReceiverID === user.UserID);
      this.setMessagesAsSeen();
      if (this.selectedConversation) {
        localStorage.setItem('lastConversationId', this.selectedConversation.ConversationID);
      }
    }
    if (!this.selectedConversation) {
      this.selectedConversation = new TdoChatConversationDataModel();
      this.selectedConversation.UserID = this.localStorageService.currentUserData.authdata.userid;
      this.selectedConversation.ReceiverID = this._selectedOnlineUser.UserID;
      this.chatService.saveConversation(this.selectedConversation).subscribe((res) => {
        this.selectedConversation = res;
        localStorage.setItem('lastConversationId', this.selectedConversation.ConversationID);
        if (!this.selectedConversation.dataTDOChats) {
          this.selectedConversation.dataTDOChats = [];
        }
      });
    }
  }
}
